export class UnsubscribeModel
{
    public email_token: string;

    public email_id: string;
    public notification_category: string;
    public active_opt_out: boolean;
    // public client_id: string = "customer-portal";
}
